module.exports = __webpack_public_path__ + "static/media/document.48af2578.svg";